import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { PtImageMappingService } from './../../../../../service/pt-image-mapping.service';

@Component({
	selector: 'app-image-log',
	templateUrl: './image-log.component.html',
	styleUrls: ['./image-log.component.scss']
})
export class ImageLogComponent implements OnInit {

	public mailingID: string = "";
	public viewImageLogRows: Array<object> = [];

	constructor(private ptImageMappingService: PtImageMappingService,
		public dialogRef: MatDialogRef<ImageLogComponent>,
		@Inject(MAT_DIALOG_DATA) public dailogData:any) {
		this.mailingID = this.dailogData.mailingID;
	}

	ngOnInit(): void {
		// SERVER CALL AND GET THE VIEW IMAGE LOG
		this.ptImageMappingService.viewImageLog(this.dailogData?.row?.mailing, this.dailogData?.row?.specimenCode).subscribe( result => {
			this.viewImageLogRows = result.logData.sort( (a, b) => +new Date(b.lastUpdatedDate) - +new Date(a.lastUpdatedDate));
		});
	}
}
